import { DEFAULT_MULTIPLIER, IMAGE_ASSETS } from '../Enums/ImageAssets';
import './Components.scss';

function BackgroundImageAsset(props: {
  name: string,
  multiplier?: number
}) {

  const asset = IMAGE_ASSETS[props.name] || null;

  if (!asset) {
    return <></>;
  }

  const multiplier = props.multiplier || DEFAULT_MULTIPLIER;

  return (
    <img className="background-asset"
      width={asset.width * multiplier}
      height={asset.height * multiplier}
      src={props.name}
    />
  );
}

export default BackgroundImageAsset;
